/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { DisposableStore } from '@vscode/observables';
import { createContext } from 'react';

// Symbol to store the context on the ViewModel class
const ViewModelContextSymbol = Symbol('ViewModelContext');
class BaseViewModel {
    constructor(props) {
        this._store = new DisposableStore();
        this.props = props;
    }
    dispose() {
        this._store.dispose();
    }
}
/** Get or create the context for a ViewModel class */
function getOrCreateViewModelContext(ctor) {
    if (!ctor[ViewModelContextSymbol]) {
        ctor[ViewModelContextSymbol] =
            createContext(undefined);
    }
    return ctor[ViewModelContextSymbol];
}
function ViewModel(props = {}) {
    var _a;
    return _a = class extends BaseViewModel {
        },
        _a._props = props,
        _a;
}

export { BaseViewModel, ViewModel, ViewModelContextSymbol, getOrCreateViewModelContext };
//# sourceMappingURL=viewModel.js.map
